import moment from 'moment';

export function getCurrencyType(invoice) {
  return invoice?.currency_type || invoice?.plan_currency || 'AUD';
}

export function getBillDates(invoice) {
  if (invoice?.bill_dates) {
    return {
      startDate: moment(invoice?.bill_dates?.start_date).format('DD MMM YYYY'),
      endDate: moment(invoice?.bill_dates?.end_date).format('DD MMM YYYY'),
    };
  }

  return {
    startDate: '',
    endDate: '',
  };
}
